import React from "react";
import { Modal, ModalBody } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { AdminButton } from "../buttons/versionHistoryBtn";
import "./modal.css";

const EditModal = ({ show, handleClose, onSubmit, values }) => {
  const navigate = useNavigate();
  return (
    <Modal centered show={show} onHide={handleClose} dialogClassName="my-modal">
      <ModalBody>
        <div className="p-2">
          <p className="fn_Nunito fw_700 fs_18 color_262c3d my-2 px-0">
            Are you sure ?
          </p>
          <p className="fn_Nunito fw_400 fs_16 color_747f9e my-2 px-0">
            Do you want to save the change ? This can not be retrieved.
          </p>
          <div className="d-flex justify-content-between">
            <AdminButton
              width="150px"
              color="white"
              border="1px solid #FF6F5B"
              background="#FF6F5B"
              type="submit"
              onClick={() => onSubmit(values)}
            >
              <span className="m-2">UPDATE</span>
            </AdminButton>
            <AdminButton
              width="150px"
              background="#7065e4"
              color="white"
              onClick={() => {
                handleClose();
              }}
            >
              <span className="m-2">CANCEL</span>
            </AdminButton>
          </div>
        </div>
      </ModalBody>
    </Modal>
  );
};

export default EditModal;
